export default {
  purchaseLimits: [],
  purchaseLimit: undefined,
};
